import { useEffect, useState } from "react";
import "./loader.css";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((old) => {
        if (old >= 90) return old; // تا ۹۰٪ نگه‌دار، بعد بقیه رو وقتی داده بیاد تموم کن
        return old + 5;
      });
    }, 150);
    return () => clearInterval(interval);
  }, []);

  return (
   <div className="loader-container d-flex flex-column justify-content-center align-items-center">
      <div className="loader-logo mb-4">
        <img
          src="/logo.png"
          alt="RazaviShop"
          style={{ width: 80, height: 80 }}
        />
        <p className="mt-3 text-muted fw-semibold">
          This demo runs on a free-tier server. Initial load may take a few
          seconds due to cold start.
        </p>
      </div>
      <div className="loader-bar w-75 bg-light rounded-pill">
        <div
          className="loader-progress bg-success rounded-pill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <p className="mt-3 text-muted fw-semibold">
        Preparing the server, please wait a moment...
      </p>
    </div>
  );
};

export default Loader;

